<template>

    <div class="custom-dropdown-container">

        <div class="custom-dropdown-box" @click.stop="handleBtnClick">
            
            <div 
                style="width: 7rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: center"
            > 
                <slot></slot>
            </div>
        </div>

        <div class="custom-dropdown-list" v-show="showList"> 
            
            <div 
                v-for="option in options"
                :key="option"
                class="custom-dropdown-option"
                @click.stop="handleOptionSelect(option)"
            >
                {{ option }}
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "CustomDropdown",
        props: {
            dropdown: {
                type: Object
            }
        },
        computed: {
            showList() {

                const { dropdownType } = this.dropdown;

                return this.$store.state[dropdownType];
            },
            options() {

                const { options } = this.dropdown;

                return options;
            }
        },
        methods: {
            handleBtnClick() {
                
                const { dropdownEventType } = this.dropdown;

                this.$store.commit(dropdownEventType, true);
            },
            handleOptionSelect(option) {

                const { dropdownEventType, optionEventType } = this.dropdown;

                const updatedOption = option.indexOf("所有") >= 0? "" : option;

                this.$store.commit(optionEventType, updatedOption);

                this.$store.commit(dropdownEventType, false);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .custom-dropdown-container {

        color: #33D1FF;

        .custom-dropdown-box {
            background-image: url(../assets/images/search/dropdown-bg.png);
            background-size: cover;
            background-repeat: no-repeat;
            background-position: 50% 50%;
            width: calc(264px / 1.8);
            height: calc(54px / 1.8);
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

        }

        .custom-dropdown-list {
            max-height: 10rem;
            overflow-y: auto;
            z-index: 20;
            position: absolute;
        }

        .custom-dropdown-option {
            background-color: #114ECB;
            line-height: 2rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: calc(264px / 1.8);
            text-align: center;
            padding: 0 1rem;
        }
    }
</style>